import './polyfills/crypto-random-uuid';

import React from 'react';
import { createRoot } from 'react-dom/client';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
import '@atlaskit/css-reset/bundle.css'; // oxlint-disable-line @atlaskit/ui-styling-standard/no-global-styles, import/extensions

import { IframeableWidgetPanel } from './components/iframe-installers/widget-panel';
import { AppBootstrap } from './components/iframe-installers/AppBootstrap';
import { configurePlatformFeatureFlags } from './feature-flags/configure-platform-feature-flags';

configurePlatformFeatureFlags();

if (process.env.NODE_ENV !== 'production' || window.parent) {
	const containerEl = document.getElementById('jcs-chat-widget-app');
	const root = createRoot(containerEl!);

	root.render(
		<AppBootstrap>
			<IframeableWidgetPanel />
		</AppBootstrap>,
	);
}
